import { mapGetters } from 'vuex'

export default {
  name: 'DataTableDashboardMixin',

  computed: {
    ...mapGetters({
      'applicationId': 'contextStore/applicationId',
      'trackerDashboard': 'contextStore/trackerDashboard'
    }),

    dashboardContext () {
      return {
        applicationId: this.applicationId,
        dashboard: this.trackerDashboard,
        searchTxt: this.searchTxt,
        filterArray: this.filterArray,
        dataTable: this.dataTableConfiguration
      }
    }
  }
}
